
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { AddOwnerPartnerComponent } from "../../../services/membership/add-owner-partner/add-owner-partner.component";
import { MembershipOwnerComponent } from "../../../services/membership/membership-owner/membership-owner.component";

@Component({
  selector: 'app-complete-company-information',
  imports: [TranslateModule, ...SHARED_COMPONENTS, AddOwnerPartnerComponent, MembershipOwnerComponent],
  templateUrl: './complete-company-information.component.html',
  styleUrl: './complete-company-information.component.scss'
})
export class CompleteCompanyInformationComponent {
  partners: any = [];
  managers: any= [];

  requiredPartners = 2;
  requiredManagers = 1;
  isOwnerModalOpen: boolean = false;

  // This method is used to ownership done
  get ownershipDone(): boolean {
    return (
      this.partners.length >= this.requiredPartners &&
      this.managers.length >= this.requiredManagers
    );
  }

  /** ─────────── ownership actions ─────────── */
  userType: string = "partner";
  // This method is used to add partner
  addPartner() {
    if (this.partners.length < this.requiredPartners) {
      this.userType = "partner";
      this.isOwnerModalOpen = true;
    }
  }
  // This method is used to add manager
  addManager() {
    if (this.managers.length < this.requiredManagers) {
      this.userType = "manage";
      this.isOwnerModalOpen = true;
    }
  }
  filesList: any = [
    {
      name: 'MOA.jpg',
      url: '/files/MOA.jpg',
      size: '120KB',
    },
  ];

  // This method is used to handle file upload using file
  handleFileUpload(file: any) {
    // handle file upload
  }

  // This method is used to handle file remove using file
  handleFileRemove(file: any) {
    this.filesList = this.filesList.filter((f: any) => f !== file);
  }
  /** ─────────── final actions ─────────── */
  // This method is used to continue
  continue() { /* route to next step */ }
  // This method is used to submit
  submit() { /* send to backend   */ }
  // This method is used to save close
  saveClose() { /* save progress and close modal/page */ }

  // This method is used to handle owner submit event using value
  onOwnerSubmit(value: any) {
    if (this.userType == "manage") {
      this.managers.push(value);
    } else {
      this.partners.push(value);
    }
  }
  // This method is used to view owner detail using value
  viewOwnerDetail(value:any){

  }
}
